import React from "react";
import Button from "../common/Button";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      {/* Optional video background */}
      {/* 
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      >
        <source src="/assets/videos/hero-bg.mp4" type="video/mp4" />
      </video>
      */}

      <div className="hero-overlay"></div>

      <div className="container hero-content">
        <h1>Sampanna Sanchar Pvt. Ltd.</h1>

        <p>Specializing in WASH-focused video production.</p>

        <div className="hero-buttons">
          <Link to="/portfolio">
            <Button variant="primary" size="large">
              View Our Work
            </Button>
          </Link>

          <Link to="/contact">
            <Button variant="outline" size="large">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
